/**
 * Balleh — checkout WhatsApp-OTP gate (front-end)
 * ===============================================
 * Intercepts the "Checkout" buttons (cart page + cart drawer), requires a
 * WhatsApp OTP via the Cloudflare worker (window.BallehOTP.endpoint), stamps the
 * verified number onto the cart, then lets checkout proceed.
 *
 * Config comes from snippets/cod-otp-modal.liquid (window.BallehOTP).
 * Backend: cod-otp-worker/.
 */
(function () {
  "use strict";

  var cfg = window.BallehOTP;
  if (!cfg || !cfg.enabled || !cfg.endpoint) return; // feature off → native checkout

  var API = String(cfg.endpoint).replace(/\/+$/, ""); // strip trailing slash
  var LANG = String(cfg.locale || "ar").slice(0, 2) === "ar" ? "ar" : "en";
  var S = (cfg.strings && cfg.strings[LANG]) || (cfg.strings && cfg.strings.ar) || {};
  var STORE_KEY = "balleh_otp_v";
  var SESSION_MS = (cfg.sessionHours || 12) * 3600 * 1000;

  var els = {}; // filled on first open
  var state = { form: null, button: null, phoneSend: "", phoneDisplay: "", resendTimer: 0 };

  // ---- verified-state (avoid re-prompting within the session) --------------
  function isVerified() {
    try {
      var v = JSON.parse(localStorage.getItem(STORE_KEY) || "null");
      return v && v.exp > Date.now();
    } catch (e) {
      return false;
    }
  }
  function setVerified(phone) {
    try {
      localStorage.setItem(STORE_KEY, JSON.stringify({ phone: phone, exp: Date.now() + SESSION_MS }));
    } catch (e) {}
  }

  // ---- intercept the checkout buttons --------------------------------------
  // Capture phase so we beat the native submit and any other click handlers.
  document.addEventListener(
    "click",
    function (e) {
      var btn = e.target.closest && e.target.closest('button[name="checkout"]');
      if (!btn || isVerified()) return; // let native checkout proceed
      e.preventDefault();
      e.stopImmediatePropagation();
      state.button = btn;
      state.form = btn.closest("form");
      openModal();
    },
    true,
  );

  // Fallback for Enter-key / programmatic submits.
  document.addEventListener(
    "submit",
    function (e) {
      var submitter = e.submitter;
      if (!submitter || submitter.name !== "checkout" || isVerified()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      state.button = submitter;
      state.form = e.target;
      openModal();
    },
    true,
  );

  // ---- modal plumbing ------------------------------------------------------
  function cacheEls() {
    var root = document.querySelector("[data-cod-otp]");
    if (!root) return false;
    els.root = root;
    els.stepPhone = root.querySelector('[data-cod-otp-step="phone"]');
    els.stepCode = root.querySelector('[data-cod-otp-step="code"]');
    els.phone = root.querySelector("[data-cod-otp-phone]");
    els.code = root.querySelector("[data-cod-otp-code]");
    els.err = root.querySelector("[data-cod-otp-err]");
    els.err2 = root.querySelector("[data-cod-otp-err2]");
    els.codesub = root.querySelector("[data-cod-otp-codesub]");
    els.send = root.querySelector("[data-cod-otp-send]");
    els.verify = root.querySelector("[data-cod-otp-verify]");
    els.resend = root.querySelector("[data-cod-otp-resend]");
    els.change = root.querySelector("[data-cod-otp-change]");
    els.closers = root.querySelectorAll("[data-cod-otp-close]");
    return true;
  }

  function applyStrings() {
    els.root.querySelectorAll("[data-s]").forEach(function (n) {
      var k = n.getAttribute("data-s");
      if (S[k]) n.textContent = S[k];
    });
    els.resend.textContent = S.resend || "Resend";
  }

  var wired = false;
  function wire() {
    if (wired) return;
    wired = true;
    els.send.addEventListener("click", onSend);
    els.verify.addEventListener("click", onVerify);
    els.resend.addEventListener("click", onResend);
    els.change.addEventListener("click", showPhoneStep);
    els.closers.forEach(function (c) {
      c.addEventListener("click", closeModal);
    });
    els.phone.addEventListener("keydown", function (e) {
      if (e.key === "Enter") onSend();
    });
    els.code.addEventListener("input", function () {
      els.code.value = els.code.value.replace(/\D/g, "");
      hide(els.err2);
      if (els.code.value.length === cfg.codeLength) onVerify();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && els.root && !els.root.hidden) closeModal();
    });
  }

  function openModal() {
    if (!cacheEls()) {
      // Modal markup missing — fail open so we never block a real customer.
      if (state.form) submitCheckout();
      return;
    }
    wire();
    applyStrings();
    showPhoneStep();
    els.root.hidden = false;
    els.root.setAttribute("aria-hidden", "false");
    document.body.classList.add("cod-otp-open");
    setTimeout(function () {
      els.phone.focus();
    }, 40);
  }

  function closeModal() {
    if (!els.root) return;
    els.root.hidden = true;
    els.root.setAttribute("aria-hidden", "true");
    document.body.classList.remove("cod-otp-open");
    clearInterval(state.resendTimer);
  }

  function showPhoneStep() {
    hide(els.err);
    els.stepCode.hidden = true;
    els.stepPhone.hidden = false;
    els.phone.focus();
  }

  function showCodeStep() {
    hide(els.err2);
    els.code.value = "";
    els.stepPhone.hidden = true;
    els.stepCode.hidden = false;
    els.codesub.textContent = (S.codeSub || "{phone}").replace("{phone}", state.phoneDisplay);
    setTimeout(function () {
      els.code.focus();
    }, 40);
  }

  // ---- actions -------------------------------------------------------------
  function readPhone() {
    var local = String(els.phone.value || "").replace(/\D/g, "");
    if (local.indexOf("0") === 0) local = local.slice(1);
    if (local.indexOf(cfg.country) === 0) local = local.slice(cfg.country.length);
    if (!/^5\d{8}$/.test(local)) return null; // Saudi mobile
    return local;
  }

  function onSend() {
    var local = readPhone();
    if (!local) return showErr(els.err, S.errPhone);
    state.phoneSend = cfg.country + local; // e.g. 9665XXXXXXXX
    state.phoneDisplay = "+" + state.phoneSend;
    hide(els.err);
    busy(els.send, S.sending);
    post("/send", { phone: state.phoneSend, lang: LANG })
      .then(function (r) {
        if (r.ok) {
          showCodeStep();
          startResend(r.resendIn || 60);
        } else {
          showErr(els.err, mapErr(r.reason));
        }
      })
      .catch(function () {
        showErr(els.err, S.errGeneric);
      })
      .then(function () {
        idle(els.send, S.send);
      });
  }

  function onVerify() {
    var code = String(els.code.value || "").replace(/\D/g, "");
    if (code.length !== cfg.codeLength) return;
    hide(els.err2);
    busy(els.verify, S.verifying);
    post("/verify", { phone: state.phoneSend, code: code })
      .then(function (r) {
        if (r.ok) {
          setVerified(state.phoneDisplay);
          // Stamp the verified number on the cart, then go — but never let a
          // slow cart API block the customer.
          return withTimeout(stampCart(state.phoneDisplay), 2500).then(function () {
            closeModal();
            submitCheckout();
          });
        }
        idle(els.verify, S.verify);
        if (r.reason === "too_many") {
          showErr(els.err2, S.errTooMany);
          setTimeout(showPhoneStep, 1200);
        } else if (r.reason === "expired") {
          showErr(els.err2, S.errExpired);
        } else {
          showErr(els.err2, (S.errInvalid || "").replace("{n}", r.remaining != null ? r.remaining : "?"));
        }
      })
      .catch(function () {
        idle(els.verify, S.verify);
        showErr(els.err2, S.errGeneric);
      });
  }

  function onResend() {
    if (els.resend.disabled) return;
    busy(els.resend, S.sending);
    post("/send", { phone: state.phoneSend, lang: LANG })
      .then(function (r) {
        if (r.ok) startResend(r.resendIn || 60);
        else {
          idleResend();
          showErr(els.err2, mapErr(r.reason));
        }
      })
      .catch(function () {
        idleResend();
        showErr(els.err2, S.errGeneric);
      });
  }
  function idleResend() {
    els.resend.disabled = false;
    els.resend.textContent = S.resend;
  }

  function startResend(sec) {
    clearInterval(state.resendTimer);
    var left = sec;
    els.resend.disabled = true;
    tick();
    state.resendTimer = setInterval(tick, 1000);
    function tick() {
      if (left <= 0) {
        clearInterval(state.resendTimer);
        els.resend.disabled = false;
        els.resend.textContent = S.resend;
        return;
      }
      els.resend.textContent = (S.resendIn || "{sec}").replace("{sec}", left);
      left--;
    }
  }

  // ---- checkout continuation ----------------------------------------------
  function submitCheckout() {
    var f = state.form,
      b = state.button;
    if (f && typeof f.requestSubmit === "function") {
      f.requestSubmit(b || undefined); // includes name="checkout" → Shopify checkout
    } else if (f) {
      // Legacy fallback: inject the checkout param and submit.
      if (b && b.name) {
        var h = document.createElement("input");
        h.type = "hidden";
        h.name = b.name;
        h.value = b.value || "";
        f.appendChild(h);
      }
      f.submit();
    } else {
      window.location.href = "/checkout";
    }
  }

  function stampCart(phone) {
    return fetch(cfg.cartUpdateUrl || "/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes: { otp_verified: "yes", otp_verified_phone: phone } }),
    });
  }

  // ---- tiny helpers --------------------------------------------------------
  function post(path, body) {
    return fetch(API + path, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    }).then(function (res) {
      return res.json().catch(function () {
        return { ok: false, reason: "bad_response" };
      });
    });
  }

  function withTimeout(promise, ms) {
    return new Promise(function (resolve) {
      var done = false;
      var t = setTimeout(function () {
        if (!done) {
          done = true;
          resolve();
        }
      }, ms);
      Promise.resolve(promise).then(fin, fin);
      function fin() {
        if (!done) {
          done = true;
          clearTimeout(t);
          resolve();
        }
      }
    });
  }

  function mapErr(reason) {
    if (reason === "cooldown" || reason === "rate_limited") return S.errRate;
    if (reason === "invalid_phone") return S.errPhone;
    return S.errGeneric;
  }

  function busy(btn, txt) {
    btn.disabled = true;
    btn.dataset.prev = btn.textContent;
    if (txt) btn.textContent = txt;
  }
  function idle(btn, txt) {
    btn.disabled = false;
    btn.textContent = txt || btn.dataset.prev || btn.textContent;
  }
  function showErr(node, msg) {
    if (!node) return;
    node.textContent = msg || S.errGeneric;
    node.hidden = false;
  }
  function hide(node) {
    if (node) node.hidden = true;
  }
})();
